import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../components/ui/select.jsx';
import { Button } from '../components/ui/button.jsx';
import { Filter, X, AlertTriangle } from 'lucide-react';
import { useFilters } from '../context/FilterContext.js';

const FilterBar = ({ n, blocked }) => {
  const { filters, options, updateFilter, resetFilters } = useFilters();

  const hasActiveFilters = filters.segmento || filters.regiao || filters.porte || (filters.periodo && filters.periodo !== 2024);

  return (
    <div className="bg-white border border-slate-200 rounded-lg p-4 shadow-sm" data-testid="filter-bar">
      <div className="flex items-center gap-3 flex-wrap">
        <Filter className="w-4 h-4 text-slate-500 shrink-0" />

        <Select value={filters.segmento || "all"} onValueChange={(v) => updateFilter('segmento', v === 'all' ? '' : v)}>
          <SelectTrigger className="w-[160px] h-9 text-sm" data-testid="filter-segmento">
            <SelectValue placeholder="Segmento" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos Segmentos</SelectItem>
            {options.segmentos.map(s => <SelectItem key={s} value={s}>{s}</SelectItem>)}
          </SelectContent>
        </Select>

        <Select value={filters.regiao || "all"} onValueChange={(v) => updateFilter('regiao', v === 'all' ? '' : v)}>
          <SelectTrigger className="w-[160px] h-9 text-sm" data-testid="filter-regiao">
            <SelectValue placeholder="Região" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todas Regiões</SelectItem>
            {options.regioes.map(r => <SelectItem key={r} value={r}>{r.charAt(0).toUpperCase() + r.slice(1)}</SelectItem>)}
          </SelectContent>
        </Select>

        <Select value={filters.porte || "all"} onValueChange={(v) => updateFilter('porte', v === 'all' ? '' : v)}>
          <SelectTrigger className="w-[140px] h-9 text-sm" data-testid="filter-porte">
            <SelectValue placeholder="Porte" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Todos Portes</SelectItem>
            {options.portes.map(p => <SelectItem key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</SelectItem>)}
          </SelectContent>
        </Select>

        <Select value={String(filters.periodo || 2024)} onValueChange={(v) => updateFilter('periodo', parseInt(v))}>
          <SelectTrigger className="w-[120px] h-9 text-sm" data-testid="filter-periodo">
            <SelectValue placeholder="Período" />
          </SelectTrigger>
          <SelectContent>
            {options.periodos.map(p => <SelectItem key={p} value={String(p)}>{p}</SelectItem>)}
          </SelectContent>
        </Select>

        {hasActiveFilters && (
          <Button variant="ghost" size="sm" onClick={resetFilters} className="text-slate-500 h-9" data-testid="reset-filters-button">
            <X className="w-4 h-4 mr-1" /> Limpar
          </Button>
        )}

        <div className="ml-auto flex items-center gap-2">
          {blocked ? (
            <div className="flex items-center gap-1.5 text-amber-600 bg-amber-50 px-3 py-1.5 rounded-md text-sm font-medium" data-testid="sample-blocked">
              <AlertTriangle className="w-4 h-4" />
              <span>n = {n} (min: 5)</span>
            </div>
          ) : n !== undefined ? (
            <div className="text-sm text-slate-600 bg-slate-50 px-3 py-1.5 rounded-md" data-testid="sample-count">
              Base: <span className="font-semibold text-blue-600">n = {n}</span>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
